import styled from 'styled-components';
import Modal from 'components/Modal';

export const ButtonsWrapper = styled.div`
  display: flex;
  margin-top: 26px;

  > button:first-child {
    margin-right: 14px;
    margin-left: auto;
  }
`;

export const StyledModal = styled(Modal)`
  width: 900px;

  p {
    margin: 5px 0;
    font-size: 12px;
  }
`;
